export const salesOrder = "salesOrder";
export const customer = "customer";
export const product = "product";
export const employee = "employee";
export const vendor = "vendor";
export const expense = "expense";